<template>
    <div class="main-container">
        <div class="container" style="padding-top:20px;">
            <section class="small-container">
                <h3 class="iconfont iconxiala" style="pointer-events:auto">图纸/方案信息</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form style="margin-bottom: 10px;" :model="drawing" status-icon :disabled="isReadOnly" inline ref="drawing" label-width="200px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="图纸/方案类型：" prop="schemeDrawingType" class="noMarginBottom">
                                <el-select
                                    class="width200"
                                    filterable
                                    clearable
                                    v-model="drawing.schemeDrawingType"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-option
                                        :key="1"
                                        label="改造方案"
                                        :value="1">
                                    </el-option>
                                    <el-option
                                        :key="2"
                                        label="施工图纸"
                                        :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="图纸/方案名称：" prop="schemeDrawingName" class="noMarginBottom">
                                <el-input v-model.trim="drawing.schemeDrawingName"
                                        :readonly="isReadOnly"
                                        size="mini"
                                        class="minWidth"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="涉及专业：" prop="purchaseCategoryName" class="noMarginBottom">
                                {{drawing.purchaseCategoryName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="drawing.purchaseCategoryId == '1'">
                            <el-form-item label="工程类型：" prop="purchaseSubCategoryName" class="noMarginBottom">
                                {{drawing.purchaseSubCategoryName}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="drawing.schemeDrawingType == 2">
                        <el-col :span="12">
                            <el-form-item label="图纸是否能明确拆除内容：" prop="dismantleFlag" class="noMarginBottom">
                                <el-radio-group
                                    filterable
                                    clearable
                                    v-model="drawing.dismantleFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="图纸中主材、设备的材质规格明确：" prop="matterFlag" class="noMarginBottom">
                                <el-radio-group
                                    filterable
                                    clearable
                                    v-model="drawing.matterFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="新增与原有系统是否分界明确：" prop="systemFlag" class="noMarginBottom">
                                <el-radio-group
                                    filterable
                                    clearable
                                    v-model="drawing.systemFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否包含节点做法安装大样详图或说明：" prop="notesFlag" class="noMarginBottom">
                                <el-radio-group
                                    filterable
                                    clearable
                                    v-model="drawing.notesFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="施工措施是否需要图纸说明(定额以外的大费用措施需要提供)：" prop="workFlag" class="noMarginBottom">
                                <el-radio-group
                                    class="width200"
                                    filterable
                                    clearable
                                    v-model="drawing.workFlag"
                                    size="mini"
                                    placeholder="请选择">
                                   <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="清单中所有施工内容是否均能在图纸中体现：" prop="allWorkFlag" class="noMarginBottom">
                                <el-radio-group
                                    class="width200"
                                    filterable
                                    clearable
                                    v-model="drawing.allWorkFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="背景描述：" prop="backDesc" class="maxWidthForm">
                                <el-input type="textarea" :rows="3" size="mini" v-model="drawing.backDesc"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="drawing.schemeDrawingType == 1">
                        <el-col :span="12">
                            <el-form-item label="计划开始时间：" prop="planBeginTime" class="noMarginBottom">
                                <el-date-picker
                                    :append-to-body="true"
                                    v-model="drawing.planBeginTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划结束时间：" prop="planEndTime" class="noMarginBottom">
                                <el-date-picker
                                    :append-to-body="true"
                                    v-model="drawing.planEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="改造原因：" prop="transformReasons" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" v-model="drawing.transformReasons" placeholder="描述改造工程的目的（维保责任范围不得纳入改造范围）"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目现状：" prop="projectSituation" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" v-model="drawing.projectSituation" placeholder="项目情况概况，应附带现场照片，说明系统情况，原始设计做法，使用年限，有无维修记录，是否在质保范围内，有无维保单位负责等内容"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="改造后效果或实现功能：" prop="transformFunction" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" v-model="drawing.transformFunction" placeholder="项目情况概况，应附带现场照片，说明系统情况，原始设计做法，使用年限，有无维修记录，是否在质保范围内，有无维保单位负责等内容"/>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :span="24">
                            <el-form-item label="改造内容：" prop="transformContent" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" v-model="drawing.transformContent" placeholder="包含工程量描述，施工范围，措施方案，设备材料的品牌材质要求。详细描述质量标准，施工做法，要求该部分能够达到形成详细清单的标准。有需要的应附施工图纸与大样图。对于施工措施与管理方式有特殊要求的（如夜间施工、高空作业、围挡措施等）需要再图纸或方案中明确标明"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="相关措施：" prop="workInfo" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" style="width：600px" v-model="drawing.workInfo" placeholder="对运营影响及其他施工影响的措施要求"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="供应商入围条件：" prop="supplierShortlistCondition" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" :rows="5" size="mini" style="width：600px" v-model="drawing.supplierShortlistCondition" placeholder="入围数量 资质要求"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="品牌是否有排他性(需3家以上同档次品牌)：" prop="brandExclFlag" class="noMarginBottom">
                                <el-radio-group
                                    class="width200"
                                    filterable
                                    clearable
                                    v-model="drawing.brandExclFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                    <el-radio
                                        key="3"
                                        :label="3"
                                        value="3">不涉及
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="技术参数是否有排他性：" prop="techExclFlag" class="noMarginBottom">
                                <el-radio-group
                                    class="width200"
                                    filterable
                                    clearable
                                    v-model="drawing.techExclFlag"
                                    size="mini"
                                    placeholder="请选择">
                                    <el-radio
                                        key="1"
                                        :label="1"
                                        value="1">是
                                    </el-radio>
                                    <el-radio
                                        key="2"
                                        :label="2"
                                        value="2">否
                                    </el-radio>
                                    <el-radio
                                        key="3"
                                        :label="3"
                                        value="3">不涉及
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <section class="small-container">
                <h3 class="iconfont iconxiala">附件</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <!-- :disabled="isReadOnly"  -->
                <el-form v-if="drawing.schemeDrawingType == 2" class="error-tip-contain" status-icon inline :model="attachementVO" ref="attachementVO" label-width="200px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="图纸：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(221, fileList)}"
                                        :files="attachementVO.drawingAttachments221"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="221">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="送样清单：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(222, fileList)}"
                                        :files="attachementVO.drawingAttachments222"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="222">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="其他附件：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(224, fileList)}"
                                        :files="attachementVO.drawingAttachments224"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="224">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-form v-if="drawing.schemeDrawingType == 1" class="error-tip-contain" :disabled="isReadOnly" status-icon inline :model="attachementVO" ref="attachementVO" label-width="200px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="方案：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(222, fileList)}"
                                        :files="attachementVO.drawingAttachments222"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="222">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目现状资料：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(223, fileList)}"
                                        :files="attachementVO.drawingAttachments223"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="223">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="其他附件：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(224, fileList)}"
                                        :files="attachementVO.drawingAttachments224"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="224">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
        </div>
    </div>
</template>
<script>
import util from "../../util";
export default {
    name: "drawing-detail",
    components: {},
    props: {
    },
    data() {
        return {
            id:this.$route.query.id,
            type: 1, //类型 1： 详情  2：编辑 3：新建
            isReadOnly: true,
            innerId: this.$route.query.id,
            categoryTreeList: [],
            drawing: {
                schemeDrawingType:1
            },
            attachementVO: {
                drawingAttachments221:[],
                drawingAttachments222:[],
                drawingAttachments223:[],
                drawingAttachments224:[]
            },
            mapAttachmentOptions: {
            }, //附件清单
            wflowFormListFlag: null
        };
    },
    watch: {
        $route(to, from) {
            this.initData();
        }
    },
    created() { },
    mounted() {
        this.initData();
        this.getTreeList();
    },
    computed: {
    },
    methods: {
        getTreeList() {
            let that = this;
            that.$root.postFunc(
                "/v1/sSuppliersCategory/public/findSuppliersCategoryTreeList",
                {
                    categoryStatus: "",
                    pageFlag: 0,
                    pageNumber: 0,
                    pageSize: 0
                },
                function (res) {
                    that.categoryTreeList = res.data.tree;
                }
            );
        },
        supDetail(supplierId) {
            this.$root.openNewBrowser(
                "#/supplier/supplierDetail?supplierId=" + supplierId
            );
        },
        selectProject() {
            this.$refs["baseInfo"].clearValidate("projectId");
        },
        approve() {
            let that = this;
            this.checkForm()
                .then(res => {
                    if (Array.isArray(res)) {
                        if (this.sSuppliersList.length == 0) {
                            this.$alert("至少选择一个供应商", {
                                type: "warning"
                            });
                            return;
                        }
                        this.save(1, 0, result => {
                            if (result) {
                                that.$router.push("/drawing/list");
                            }
                        });
                    } else {
                        this.$alert(res, {
                            type: "warning"
                        });
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        },
        initData() {
            this.type = "1";
            this.innerId = this.$route.query.id;
            this.getDetail();
        },
        getDetail() {
            let that = this;
            this.$root.getFunc(
                "/v1/sSchemeDrawing/getExtSSchemeDrawing/" + this.innerId,
                resz => {
                    let res = resz.data
                    that.drawing = res.data
                    console.log(that.drawing)
                    that.sSuppliersList = res.data.drawingSupplierList ||[]
                    that.sSuppliersList.forEach(item=>{
                        item.companyName = item.suppliersName
                        item.contactName = item.mainContactName
                        item.contactMobile = item.mainContactMobile
                    })
                    that.attachementVO['drawingAttachments221'] = res.data.mapAttachments[221] || []
                    that.attachementVO['drawingAttachments222'] = res.data.mapAttachments[222] || []
                    that.attachementVO['drawingAttachments223'] = res.data.mapAttachments[223] || []
                    that.attachementVO['drawingAttachments224'] = res.data.mapAttachments[224] || []
                }
            );
        },
        saveToDraft() {
            this.save(0, () => { });
        },
        submit() {
            let that = this;
            this.checkForm()
                .then(res => {
                    this.save(1, 0, result => {
                        if (result) {
                            that.$router.push("/drawing/list");
                        }
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        },
        checkForm() {
            let checkPromise = [];
            checkPromise.push(this.submitFormPromise("baseInfo"));
            checkPromise.push(this.submitFormPromise("attachementVO"));

            return Promise.all(checkPromise)
                .then(data => {
                    console.log(data);
                    return data;
                })
                .catch(e => {
                    console.log(e);
                    return e;
                });
        },
        submitFormFnc(formName) {
            let that = this;
            var f = function () {
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if (Array.isArray(that.$refs[formName])) {
                        form = that.$refs[formName][0];
                    }
                    if (form) {
                        form.validate(valid => {
                            if (valid) {
                                resolve(true);
                            } else {
                                reject("请完成必填信息的填写！");
                            }
                        });
                    } else {
                        resolve(true);
                    }
                });
                return p;
            };
            return f;
        },
        resetForm(formName) {
            let that = this;
            let form = that.$refs[formName];
            if (Array.isArray(that.$refs[formName])) {
                form = that.$refs[formName][0];
            }
            if (form) {
                form.resetFields();
            }
        },
        submitFormPromise(formName) {
            return this.submitFormFnc(formName)();
        },
        save(saveFlag, fn) {
            let that = this;
            let suppliers = [];
            this.sSuppliersList.forEach((item, index) => {
                suppliers.push({
                    id: item.id,
                    suppliersId: item.id,
                    mainContactName: item.contactName,
                    mainContactMobile: item.contactMobile,
                    suppliersName: item.companyName
                });
            });
            // debugger
            let formParams = {
                ...that.baseInfo,
                ...that.drawing
            };
            formParams.drawingSupplierList = suppliers
            formParams.mapAttachments = that.mapAttachmentOptions
            if (saveFlag == 1 && this.type != "1") {
                formParams.toOAFlag = 1;
            }
            this.$root.postFunc(
                "/v1/sSchemeDrawing/saveOrUpdate",
                formParams,
                function (res) {
                    that.$alert(saveFlag?"提交审批成功":"保存成功", {
                        confirmButtonText: "确定",
                        type: "success",
                        callback: action => {
                            fn(true);
                            that.$router.push("/drawing/list")
                        }
                    });
                },
            );
        },
        deleteSelectSupplier(index, item) {
            this.sSuppliersList.splice(index, 1);
        },
        open(name, fn) {
            const h = this.$createElement;
            this.$msgbox({
                title: "请确定本次招标是否唯一供应商？",
                message: h("div", {}, [
                    h(
                        "p",
                        {
                            style: {
                                border: "1px solid #e9e9e9"
                            }
                        },
                        [
                            h(
                                "h3",
                                {
                                    style: {
                                        margin: 0,
                                        backgroundColor: "#e9e9e9",
                                        lineHeight: "35px",
                                        padding: 0,
                                        textAlign: "center"
                                    }
                                },
                                "供应商名称"
                            ),
                            h(
                                "p",
                                {
                                    style: {
                                        textAlign: "center",
                                        lineHeight: "35px"
                                    }
                                },
                                name
                            )
                        ]
                    ),
                    h(
                        "span",
                        {
                            style: {
                                textAlign: "left",
                                marginTop: "5px"
                            }
                        },
                        "注: 唯一供应商不发送邀请函"
                    )
                ]),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            }).then(action => {
                if (action === "confirm") {
                    fn();
                }
            });
        },
        selectSuppliersCallback(val) {
            this.sSuppliersList = val || [];
        },
        addPayment() {
            var item = {
                paymentName: "",
                paymentRatio: "",
                paymentConditions: ""
            };
            this.wFlowFormInfoPaymentList.push(item);
        },
        removePayment(index) {
            var form = "payment" + index;
            this.$refs[form][0].resetFields();
            this.wFlowFormInfoPaymentList.splice(index, 1);
        },
        chooseSupplier() {
            this.sSuppliersList.forEach(item => {
                item.existFlag = true;
                this.$refs['selectSupplier'].selectSupplierList = this.sSuppliersList
            })
            this.$refs["selectSupplier"].showDialog();
        },
        cancel() { },
        finishUpload(fileType, fileList) {
            // debugger
            this.mapAttachmentOptions[fileType] = fileList.fileList;
        },
        showSupplierRegSimple() {
            this.$refs["assd"].show = true;
        },
        toDownload(url, name) {
            window.location.href = url;
        }
    },

};
</script>

<style scoped lang="scss">
    @import '../../assets/_var.scss';
    @import "../../assets/iconfont/iconfont.css";
.main-container {
    margin: 30px 100px;
}
.container /deep/ {
  margin-top: -14px;
  padding-bottom: 15px;
  background-color: #ffffff;

  .el-message-box {
    width: 500px;
  }

  .text-button.el-button {
    font-size: 16px;
    text-align: left;
    color: #333333;
    line-height: 21px;
    background: white;
    border: none;
  }

  .text-button.el-button--mini {
    padding: 0 15px;
  }

  .f14 {
    font-size: 14px !important;
  }

  & .unit {
    width: 100px;
    margin-right: 5px;
  }

  & .tip {
    margin-left: 10px;
    color: $--primary-color;
    font-size: 12px;
  }

  & .add {
    float: right;
    font-size: 14px;
    cursor: pointer;
    & img {
      vertical-align: middle;
      width: 70px;
      height: 26px;
    }
  }
  & .dele {
    position: absolute;
    top: 0px;
    right: 10px;
  }
  & .dele img {
    transform: scale(1);
    transition: 0.5s;
    width: 34px;
    height: 34px;
  }
  .dele:hover img {
    transform: scale(1.1);
  }
  & .remarks {
    width: 95%;
  }

  & .naturalForm {
    padding: 20px 10px 5px;
    padding-left: 0px;
    padding-right: 26px;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    margin-bottom: 20px;
  }

  & h4 {
    padding: 0 30px;
    text-align: left;
    line-height: 50px;
    color: $--text-color-light;
    background: $--secondary-fill-color;
    overflow: hidden;
    position: relative;
  }
  & h4 {
    text-indent: 10px;
    line-height: 35px;
    background: $--primary-fill-color;
  }

  .attachmentForm {
    .el-form-item__content {
      // width: 250px;
    }
  }

  .el-input__inner {
    border: none;
    border-bottom: 1px solid #c4c4c4;
    border-radius: 0px;
  }

  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: white;
    cursor: default;
  }

  .maxWidthForm {
    width: 100%;
    .el-form-item__content {
      width: calc(100% - 260px);
    }
  }

  .onlySupplier {
    .file-list .file-name {
      //max-width: 190px!important;
    }
  }

  .el-form-item {
    width: 100%;
  }
  .el-form-item__error {
    width: 300px;
    padding: 0;
  }

  .el-form-item__label,
  .el-form-item__content {
    line-height: 33px;
  }
}
.box-card {
  margin-bottom: 15px;
}
.minWidth {
  width: 250px !important;
}

.colorLine {
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
}

h2 {
  font-size: 13px;
  margin-left: 20px;
}
.noMarginBottom {
  // margin-bottom: 0!important;
  margin-bottom: 10px !important;
  .tipWrap {
    position: relative;
    min-width: 250px;
    .tips {
      position: absolute;
      top: 16px;
      left: 100px;
      padding-left: 20px;
      font-size: 12px;
      color: $--text-color-light;
    }
  }
}

.cf:before,
.cf:after {
  content: "";
  display: table;
}
.cf:after {
  clear: both;
}
.line-display {
  display: inline-flex;
  width: 100%;
  .yanbiao.el-button {
    float: right;
    margin-top: 10px;
  }
}

.error-tip-contain /deep/ {
  .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 14%;
    left: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/common/drawingDetail.vue